<template>
  <g>
    <path
      d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 15.75L18 8.25"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5 8.25L19.5 8.25"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.25 15.75L5.25 8.25"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.25 15.75L8.25 8.25"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.25 12.75L8.25 12.75"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.75,8.25a1.5,1.5,0,0,0-1.5,1.5v4.5a1.5,1.5,0,0,0,3,0V9.75A1.5,1.5,0,0,0,12.75,8.25Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconAccept",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>
